import Moment from "moment";

import {
    DELETE_CAMPAIGN_SUCCESS,
    DELETE_CAMPAIGN_BEGIN,
    FETCH_CAMPAIGN_BEGIN,
    FETCH_CAMPAIGN_SUCCESS,
    CREATE_CAMPAIGN_BEGIN,
    CREATE_CAMPAIGN_FAILURE,
    UPDATE_CAMPAIGN_BEGIN,
    UPDATE_CAMPAIGN_FAILURE,
    UPDATE_CAMPAIGN_SORT,
    PUBLISH_TO_JIRA,
    PUBLISH_TO_JIRA_SUCCESS,
    FETCH_CAMPAIGN_META_SUCCESS
} from '../actions/campaignActions';


const initialState = {
    campaign: {
        campaign: {},
        units: [],
        input_options: []
    },
    meta: {},
    sort_col: false,
    sort_dir: false,
    loading: false,
    error: null,
    errors: [],
    jira_errs: [],
    jira_urls: [],
    message: false,
    e_message: false
};

export default function campaignReducer(state = initialState, action) {

    switch (action.type) {
        case FETCH_CAMPAIGN_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_CAMPAIGN_SUCCESS:
            return {
                ...state,
                loading: false,
                message: false,
                campaign: action.payload.result,
                permission: action.payload.result.permission
            };


        case DELETE_CAMPAIGN_BEGIN:
            return {
                ...state,
                loading: true,
            };


        case DELETE_CAMPAIGN_SUCCESS:
            return {
                ...initialState,
                loading: false
            };

        case CREATE_CAMPAIGN_BEGIN:
            return {
                ...state,
                loading: true,
                errors: [],
                error: false
            };

        case UPDATE_CAMPAIGN_BEGIN:
            return {
                ...state,
                loading: true,
                errors: [],
                error: false
            };

        case UPDATE_CAMPAIGN_FAILURE:
            return {
                ...state,
                loading: false,
                error: true,
            };

        case CREATE_CAMPAIGN_FAILURE:
            return {
                ...state,
                loading: false
            };

        case UPDATE_CAMPAIGN_SORT:
            return {
                ...state,
                sort_col: action.payload.sort_col,
                sort_dir: action.payload.sort_dir
            };
        case PUBLISH_TO_JIRA:
            return {
                ...state,
                loading: true,
                jiraLoading: true,
                error: false,
                message: false
            };
        case PUBLISH_TO_JIRA_SUCCESS:
            return {
                ...state,
                loading: false,
                jiraLoading: false,
                error: false,
                jira_url: action.payload.urls,
                message: action.payload.message,
                jira_errs: action.payload.err_stack,
                err_message: action.payload.err_message
            }
        case FETCH_CAMPAIGN_META_SUCCESS:
            return{
                ...state,
                meta: action.payload.result
            }

        default:
            return state;
    }
}
